<template>
  <div v-if="!loader && good">
    <p class="menu-label">
      УСПЕШНО
    </p>
    <article class="message is-success">
      <div class="message-header">
        <p>Обращение №{{complete_data['ID']}} успешно зарегистрировано!</p>
        <button class="delete" aria-label="delete"></button>
      </div>
      <div class="message-body">
        <p>
          <strong>Неисправность: </strong> {{form.failure.value}}
        </p>
        <p>
          <strong>Описание: </strong> {{form.comment.value}}
        </p>
        <p>
          <strong>Заявитель: </strong> {{$store.getters.USER.data['Наименование']}}
        </p>
      </div>
    </article>
    <hr>
    <button class="button is-dark" v-on:click="$router.push('/')">К ОБРАЩЕНИЯМ</button>
  </div>
  <div v-if="loader && !good">
    <Loader type="send"/>
  </div>
  <div v-if="!loader && !good">
    <p class="menu-label">
      СОЗДАТЬ ОБРАЩЕНИЕ
    </p>
    <div class="my-dev" v-if="false">
      <p class="menu-label">
        ОТЛАДОЧНЫЕ ДАННЫЕ
      </p>
      <p><strong>Контракт:</strong> {{ contract_GUID }}</p>
      Шаг: {{ get_data().c }} из {{ get_data().l }}
      <pre>
        {{ form.location }}
      </pre>
    </div>
    <div class="my-form" :style="(get_data().c !== get_data().l) ? `background-color: rgba(248, 181, 11, 0.${get_data().c})` : `background-color: rgba(45, 140, 0, 0.5)`">
<!--      <progress class="progress is-normal" :value="get_data().c" :max="get_data().l"></progress>-->

      <div class="columns">
        <div class="column is-half">
          <!-- ОРГ. ИСПОЛНИТЕЛЬ -->
          <div class="field">
            <label class="label">Организация исполнитель</label>
            <div class="control has-icons-left">
              <div class="select is-dark">
                <select v-model="form.executor.value" v-on:change="validate('executor')">
                  <option :value="executor['Код']" v-for="(executor) in form.executor.data" :key="executor['Код']">{{ executor['Наименование'] }}</option>
                </select>
              </div>
              <div class="icon is-small is-left">
                <font-awesome-icon icon="fa-solid fa-building" />
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <!-- ФИЗ. ОБЪЕКТ -->
          <div class="field" v-if="form.executor.valid">
            <label class="label">Физический объект</label>
            <div class="control has-icons-left has-icons-right">
              <div class="select is-dark">
                <select v-model="form.object.value" v-on:change="validate('object')">
                  <option :value="object['ФизОбъектСсылка']" v-for="object in form.object.data" :key="object['ФизОбъектСсылка']">{{ object['ФизОбъектНаименование'] }}</option>
                </select>
              </div>
              <div class="icon is-small is-left">
                <font-awesome-icon icon="fa-solid fa-city" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- МЕСТОПОЛОЖЕНИЕ -->
      <label class="label" v-if="form.object.valid && !form.location.skipped">Местоположение</label>
      <div class="field columns" v-if="form.object.valid">
        <div class="column is-four-fifths" v-if="!form.location.skipped">
          <div class="control has-icons-left">
            <div class="select" v-if="form.location.data && form.location.data.length > 0">
              <select v-model="form.location.value" v-on:change="validate('location')">
                <option :value="location['Наименование']" v-for="location in form.location.data" :key="location">{{ location['Наименование'] }}</option>
              </select>
            </div>
            <input v-else v-on:input="validate('location')" maxlength="250" class="input" type="text" placeholder="Местоположение" v-model="form.location.value" />

            <p class="icon is-left">
              <font-awesome-icon icon="fa-solid fa-location-dot" />
            </p>
          </div>
        </div>
        <div class="column" :class="{ 'is-one-fifth' : !form.location.skipped }">
          <div class="button" v-if="!form.location.skipped" style="width: 100% !important;" v-on:click="skipStep('location')">
            <span>Пропустить</span>
          </div>
          <div class="button" v-else style="width: 100% !important;" v-on:click="turnOnStem('location')">Добавить местоположение</div>
        </div>
      </div>

      <!-- НЕИСПРАВНОЕ ОБОРУДОВАНИЕ -->
      <label class="label" v-if="form.location.valid && !form.equipment.skipped">Неисправное оборудование</label>
      <div class="field columns" v-if="form.location.valid">
        <div class="column is-four-fifths" v-if="!form.equipment.skipped">
          <div class="control has-icons-left">
            <input v-on:input="validate('equipment')" class="input" type="text" placeholder="Наименование" v-model="form.equipment.value" />
            <p class="icon is-left">
              <font-awesome-icon icon="fa-solid fa-video" />
            </p>
          </div>
        </div>
        <div class="column" :class="{ 'is-one-fifth' : !form.equipment.skipped }">
          <div class="button" v-if="!form.equipment.skipped" style="width: 100% !important;" v-on:click="skipStep('equipment')">
            <span>Пропустить</span>
          </div>
          <div class="button" v-else style="width: 100% !important;" v-on:click="turnOnStem('equipment')">Добавить неисправное оборудование</div>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <!-- ПОДСИСТЕМА -->
          <div class="field" v-if="form.equipment.valid">
            <label class="label">Подсистема</label>
            <div class="control has-icons-left has-icons-right">
              <div class="select is-dark">
                <select v-model="form.system.value" v-on:change="validate('system')">
                  <option :value="system['ПодсистемаНаименование']" v-for="system in form.system.data" :key="system['ПодсистемаКод']">{{ system['ПодсистемаНаименование'] }}</option>
                </select>
              </div>
              <div class="icon is-small is-left">
                <font-awesome-icon icon="fa-solid fa-server" />
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <!-- НЕИСПРАВНОСТЬ -->
          <label class="label" v-if="form.system.valid">Неисправность</label>
          <div class="field columns" v-if="form.system.valid">
            <div class="column is-four-fifths" v-if="!form.failure.skipped" :class="(form.object.value === 'Задачи' && !form.failure.skipped) ? 'is-four-fifths' : 'is-full'">
              <div class="control has-icons-left has-icons-right">
                <div class="select is-dark">
                  <select v-model="form.failure.value" v-on:change="validate('failure')" :disabled="hidden_failure.includes(form.object.value)">
                    <option :value="fail['Наименование']" v-for="fail in form.failure.data" :key="fail['Наименование']">{{ fail['Наименование'] }}</option>
                  </select>
                </div>
                <div class="icon is-small is-left">
                  <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
                </div>
              </div>
            </div>
            <div class="column" :class="{'is-one-fifth' : !form.failure.skipped}">
              <div class="button" v-if="!form.failure.skipped" style="width: 100% !important;" v-on:click="skipStep('failure')">Пропустить</div>
              <div class="button" v-else style="width: 100% !important;" v-on:click="turnOnStem('failure')">Добавить причину неисправности</div>
            </div>
          </div>
        </div>
      </div>

      <!-- ОПИСАНИЕ -->
      <div class="field" v-if="form.failure.valid">
        <div class="control has-icons-left has-icons-right">
          <textarea v-on:input="validate('comment')" maxlength="250" class="input" type="text" placeholder="Описание" v-model="form.comment.value" />
          <p class="icon is-left">
            <font-awesome-icon icon="fa-solid fa-comment" />
          </p>
          <p class="icon is-right">
            <font-awesome-icon v-if="form.comment.valid" icon="fa-solid fa-check" />
            <font-awesome-icon v-else icon="fa-solid fa-xmark" />
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <!-- ПРИОРИТЕТ -->
          <div class="field" v-if="form.comment.valid">
            <label class="label">Приоритет</label>
            <div class="control has-icons-left">
              <div class="select">
                <select v-model="form.priority.value" v-on:change="validate('priority')">
                  <option v-for="(element, index) in form.priority.data" :key="index">{{ element }}</option>
                </select>
              </div>
              <div class="icon is-small is-left">
                <font-awesome-icon icon="fa-solid fa-list-check" />
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <!-- ВИД СЕРВИСА -->
          <div class="field" v-if="form.comment.valid">
            <label class="label">Вид сервиса</label>
            <div class="control has-icons-left">
              <div class="select is-dark">
                <select v-model="form.service.value" v-on:change="validate('service')">
                  <option :value="service" v-for="service in form.service.data" :key="service['Код']">{{ service }}</option>
                </select>
              </div>
              <div class="icon is-small is-left">
                <font-awesome-icon icon="fa-solid fa-building" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="has-text-centered" v-if="form.executor.valid && form.object.valid && form.location.valid && form.system.valid && form.failure.valid && form.comment.valid && form.priority.valid && form.service.valid">
        <button class="button my-button" v-on:click="CreateTicket()">ПОДАТЬ ОБРАЩЕНИЕ</button>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader";
export default {
  name: 'HomeView',
  components: {Loader},
  async beforeMount() {
    await this.getExecutorList(this.$store.getters.TOKEN)
    await this.getObjects(this.form.executor.value)
  },
  data() {
    return {
      loader: false,
      good: false,
      complete_data: null,
      hidden_failure: ['56500aa6-67a1-11e8-9499-002590c134db'],
      contract_GUID: '',
      form: {
        executor: {
          value: null,
          guid: null,
          valid: false,
          data: null
        },
        object: {
          value: null,
          guid: null,
          valid: false,
          data: null
        },
        location: {
          data: null,
          value: null,
          valid: false,
          skipped: false
        },
        equipment: {
          data: null,
          value: null,
          valid: false,
          skipped: false
        },
        system: {
          value: null,
          guid: null,
          valid: false,
          data: null
        },
        failure: {
          value: null,
          guid: null,
          valid: false,
          data: null,
          skipped: false
        },
        comment: {
          value: null,
          valid: false
        },
        priority: {
          value: null,
          valid: false,
          data: ["Высокий (Критичный)", "Стандартный", "Низкий"]
        },
        service: {
          value: null,
          valid: false,
          guid: null,
          data: [
              "Инцидент (аварийное обращение)",
              "Заявка на отчет, инструктаж, помощь",
              "Заявка на СМР / ПНР",
              "Заявка на дополнительные / прочие работы",
              "Заявка на техническое обслуживание",
              "Заявка на испытание",
              "Ложная сработка",
              "Плановые работы",
              "Не сдан под охрану"
          ]
        }
      }
    }
  },
  methods: {
    CreateTicket: async function () {
      let toSend = {}

      toSend.applicant = this.$store.getters.USER.data['Ссылка']
      toSend.executor = this.form.executor.guid
      toSend.object = this.form.object.guid
      if (!this.form.location.skipped) {
        toSend.location = this.form.location.value
      }
      toSend.system = this.form.system.guid
      if (!this.form.failure.skipped) {
        toSend.failure = this.form.failure.guid
      }
      if (!this.form.equipment.skipped) {
        toSend.equipment = this.form.equipment.value
      }
      toSend.comment = this.form.comment.value
      toSend.priority = this.form.priority.value
      toSend.service = this.form.service.value

      await this.makeCreate(toSend)
    },
    makeCreate: async function (to_send) {
      this.loader = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/CreateDoc`
      let properies = {
        method: 'POST',
        body: JSON.stringify(to_send),
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }

      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            this.loader = false
            this.good = true
            this.complete_data = JSON.parse(result)
          })
    },
    turnOnStem: async function (step) {
      switch (step) {
        case 'location':
          this.form.location = {
            value: null,
            valid: false,
            skipped: false
          }
          await this.getLocation()
          this.clear_field('system')
          break;
        case 'equipment':
          this.form.equipment = {
            value: null,
            valid: false,
            skipped: false
          }
          break;
        case 'failure':
          this.form.failure = {
            value: null,
            valid: false,
            skipped: false
          }
          await this.validate('system')
          break;
      }
    },
    skipStep: async function (step) {
      switch (step) {
        case 'location':
          this.form.location = {
            data: null,
            value: null,
            valid: true,
            skipped: true
          }
          await this.getSystemList(this.form.object.guid)
          break;
        case 'equipment':
          this.form.equipment = {
            data: null,
            value: null,
            valid: true,
            skipped: true
          }
          await this.getSystemList(this.form.object.guid)
          break;
        case 'failure':
          this.form.failure = {
            value: null,
            guid: null,
            valid: true,
            data: null,
            skipped: true
          }
          break;
      }
    },
    getExecutorList: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetExecutorList`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }

      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            this.$store.dispatch('EXECUTORS', JSON.parse(result))

            for (let executor of JSON.parse(result)) {
              if (executor['Наименование'] === this.$config.DEFAULT_EXECUTOR) {
                this.form.executor.value = executor['Код']
                this.form.executor.guid = executor['Ссылка']
                this.form.executor.valid = true
              }
            }
            this.form.executor.data = JSON.parse(result)
          })
    },
    getObjects: async function (id) {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetObjects`
      let data = {
        "code": id
      }
      let properies = {
        method: 'POST',
        withCredentials: true,
        body: JSON.stringify(data),
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }

      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            this.form.object.data = null
            this.form.object.data = JSON.parse(result)
          })
    },
    getLocation: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetLocations`
      let data = {
        "objectGUID": this.form.object.guid
      }
      let properies = {
        method: 'POST',
        withCredentials: true,
        body: JSON.stringify(data),
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }

      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            this.form.location.data = null
            this.form.location.data = JSON.parse(result)
            /*if (this.form.location.data.length === 0) {
              this.skipStep('location')
            }*/
          })
    },
    getSystemList: async function (objectGUID) {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetSystemList`
      let data = {
        "contractGUID": this.contract_GUID,
        "objectGUID": objectGUID
      }
      let properies = {
        method: 'POST',
        body: JSON.stringify(data),
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }

      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            this.form.system.data = null
            this.form.system.data = JSON.parse(result)
          })
    },
    getFailures: async function (systemCode) {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetFailures`
      console.log(systemCode)
      let data = {
        "code": systemCode
      }
      let properies = {
        method: 'POST',
        body: JSON.stringify(data),
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }

      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            this.form.failure.data = null
            this.form.failure.data = JSON.parse(result)
            console.log( JSON.parse(result).length)
          })
    },
    validate: async function (type) {
      let tmp_var = []
      switch (type) {
        case 'executor':
          this.clear_field('object')
          for (let object of this.form.executor.data) {
            if (object['Код'] === this.form.executor.value) {
              this.form.executor.guid = object['Ссылка']
            }
          }
          this.form.executor.value !== null ? this.form.executor.valid = true : this.form.executor.valid = false
          await this.getObjects(this.form.executor.value)
          break;
        case 'object':
          this.clear_field('location')
          for (let object of this.form.object.data) {
            if (object['ФизОбъектНаименование'] !== null) {
              tmp_var.push(object['ФизОбъектСсылка'])
            }
          }

          if (tmp_var.includes(this.form.object.value)) {
            this.form.object.valid = true
            for (let object of this.form.object.data) {
              if (object['ФизОбъектСсылка'] === this.form.object.value) {
                this.form.object.guid = object['ФизОбъектСсылка']
                this.contract_GUID = object['СсылкаДоговор']
              }
            }
          } else {
            this.form.object.valid = false
          }
          await this.getLocation()
          break;
        case 'location':
          this.clear_field('equipment')
          this.form.location.value !== null      ? this.form.location.valid = true : this.form.location.valid = false
          this.form.location.value !== undefined ? this.form.location.valid = true : this.form.location.valid = false
          this.form.location.value !== ''        ? this.form.location.valid = true : this.form.location.valid = false
          break;
        case 'system':
          for (let system of this.form.system.data) {
            if (system['ПодсистемаНаименование'] !== null) {
              tmp_var.push(system['ПодсистемаНаименование'])
            }
          }
          if (tmp_var.includes(this.form.system.value)) {
            this.form.system.valid = true
            if (this.hidden_failure.includes(this.form.object.value)) {
              console.log('Пропускаю этап Failure')
              this.skipStep('failure')
            } else {
              for (let system of this.form.system.data) {
                if (system['ПодсистемаНаименование'] === this.form.system.value) {
                  this.form.system.guid = system['ПодсистемаСсылка']
                  await this.getFailures(system['ПодсистемаКод'])
                }
              }
            }
          } else {
            this.form.system.valid = false
          }
          break;
        case 'failure':
          this.clear_field('comment')
          for (let fail of this.form.failure.data) {
            if (fail['Наименование'] !== null) {
              tmp_var.push(fail['Наименование'])
            }
          }
          if (tmp_var.includes(this.form.failure.value)) {
            for (let fail of this.form.failure.data) {
              if (fail['Наименование'] === this.form.failure.value) {
                this.form.failure.guid = fail['Ссылка']
                this.form.failure.valid = true
              }
            }
          } else {
            this.form.failure.valid = false
          }
          break;
        case 'comment':
          this.form.comment.value !== null      ? this.form.comment.valid = true : this.form.comment.valid = false
          this.form.comment.value !== undefined ? this.form.comment.valid = true : this.form.comment.valid = false
          this.form.comment.value !== ''        ? this.form.comment.valid = true : this.form.comment.valid = false
          if (this.form.comment.valid) {
            this.form.priority.value = 'Стандартный'
            this.form.priority.valid = true
          }
          if (this.form.priority.valid) {
            this.form.service.value = 'Инцидент (аварийное обращение)'
            this.form.service.valid = true
          }
          break;
        case 'priority':
          this.form.priority.value !== null ? this.form.priority.valid = true : this.form.priority.valid = false
          break;
        case 'equipment':
          this.clear_field('system')
          this.form.equipment.value !== null      ? this.form.equipment.valid = true : this.form.equipment.valid = false
          this.form.equipment.value !== undefined ? this.form.equipment.valid = true : this.form.equipment.valid = false
          this.form.equipment.value !== ''        ? this.form.equipment.valid = true : this.form.equipment.valid = false
          await this.getSystemList(this.form.object.guid)
          break;
        case 'service':
          this.form.service.value !== null ? this.form.service.valid = true : this.form.service.valid = false
          break;
        default:
          console.log('Не опознана валидация')
      }
    },
    clear_field: function (type) {
      switch (type) {
        case 'executor':
          this.clear_field('object')
          break;
        case 'object':
          this.form.object = {
            value: null,
            guid: null,
            valid: false,
            data: null
          }
          this.clear_field('location')
          break;
        case 'location':
          this.form.location = {
            data: null,
            value: null,
            valid: false,
            skipped: false
          }
          this.clear_field('equipment')
          break;
        case 'equipment':
          this.form.equipment = {
            data: null,
            value: null,
            valid: false,
            skipped: false
          }
          this.clear_field('system')
          break;
        case 'system':
          this.form.system = {
            value: null,
            guid: null,
            valid: false,
            data: null
          }
          this.clear_field('failure')
          break;
        case 'failure':
          this.form.failure = {
            value: null,
            guid: null,
            valid: false,
            data: null
          }
          this.clear_field('comment')
          break;
        case 'comment':
          this.form.comment = {
            value: null,
            valid: false
          }
          this.clear_field('priority')
          break;
        case 'priority':
          this.form.priority = {
            value: null,
            valid: false,
            data: ["Высокий (Критичный)", "Стандартный", "Низкий"]
          }
          break;
        case 'service':
          this.form.service = {
            value: null,
            valid: false,
            guid: null,
            data: [
              "Инцидент (аварийное обращение)",
              "Заявка на отчет, инструктаж, помощь",
              "Заявка на СМР / ПНР",
              "Заявка на дополнительные / прочие работы",
              "Заявка на техническое обслуживание",
              "Заявка на испытание",
              "Ложная сработка",
              "Плановые работы",
              "Не сдан под охрану"
            ]
          }
          break;
        default:
          console.log('Ошибка очистки')
      }
    },
    get_data: function () {
      let length = Object.keys(this.form).length;
      let completed = 0

      for (let key of Object.keys(this.form)) {
        if (this.form[key].valid) {
          completed++
        }
      }
      let ret = {
        l: length,
        c: completed
      }

      return ret
    }
  }
}
</script>

<style lang="scss" scoped>
$dev-slider: 300px;


.progress-circles {
  .circle {
    border: 2px #000000 solid;
    aspect-ratio: 1 / 1 !important;
    border-radius: 20px;
    padding: 10px;
  }
}

.my-form {
  background: #ffffff;
  padding: 1em;
  box-shadow:
      0 0 0 1px rgb(194, 192, 184) inset,
      0 5px 0 -4px rgb(255, 255, 255),
      0 5px 0 -3px rgb(194, 192, 184),
      0 11px 0 -8px rgb(255, 255, 255),
      0 11px 0 -7px rgb(194, 192, 184),
      0 17px 0 -12px rgb(255, 255, 255),
      0 17px 0 -11px rgb(194, 192, 184);
}
textarea {
  resize: vertical;
  min-height: 120px;
}

select, .select {
  width: 100% !important;
}
.select:not(.is-multiple):not(.is-loading)::after {
  color: red;
}
</style>
